import React from "react";
import { Card, CardContent } from "./card";
import { Button } from "./button";

const NewsletterCard = () => {
  return (
    <>
      <Card className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-950/20 dark:to-purple-900/20">
        <CardContent className="p-6 text-center">
          <h3 className="font-semibold mb-2">Stay Updated</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Get notified about new articles and insights.
          </p>
          <Button
            size="sm"
            className="bg-purple-600 hover:bg-purple-700 w-full"
            onClick={() => {
              document
                .getElementById("main-footer")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Subscribe to Newsletter
          </Button>
        </CardContent>
      </Card>
    </>
  );
};

export default NewsletterCard;
